import { render, staticRenderFns } from "./ArticleCardBNG.vue?vue&type=template&id=e6f58fd4&scoped=true&"
import script from "./ArticleCardBNG.vue?vue&type=script&lang=js&"
export * from "./ArticleCardBNG.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCardBNG.vue?vue&type=style&index=0&id=e6f58fd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f58fd4",
  null
  
)

export default component.exports